import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

interface Props {
  backgroundColor?: string;
  textColor?: string;
  isOvertime?: boolean;
  isDimmed?: boolean;
  isTextCenter?: boolean;
  hours?: number; // Hours value for CSS calc (0-8 for regular, 0-8 for overtime)
}

export const OuterWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const RightSectionContainer = styled.div`
  width: 100%;
  padding-inline: var(--space-24);
  height: auto;
`;

export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: fit-content;
`;

export const MemberRow = styled.div`
  width: 100%;
  padding-block: var(--space-12);
  ${AlignCenter}
  gap: var(--space-12);
  box-shadow: var(--bottom-border);
  &:last-child {
    border-bottom: unset;
  }
`;

export const WorkloadCellContainer = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  min-height: 82px;
  height: max-content;
  padding: var(--space-4);
  box-shadow: var(--border);
  border-radius: var(--border-radius-12);
  background-color: var(--background-tertiary);
  min-width: 88px;
`;

export const WorkloadCell = styled.div<Props>`
  /* min-width: 87px; */
  width: 100%;
  /* Use CSS calc() instead of JavaScript calculation - height proportional to hours */
  --hours: ${(props) => props.hours ?? 0};
  --base-height: 82px;
  /* Calculate height: (hours / 8) * 82px, with min of 0 and default to 82px if hours is 0 */
  height: ${(props) =>
    props.hours === undefined || props.hours === 0 ? '82px' : `max(0px, calc(var(--hours) / 8 * var(--base-height)))`};
  background-color: ${(props) => (props.isDimmed ? 'transparent' : props.backgroundColor)};
  opacity: ${(props) => (props.isDimmed ? 0.8 : 1)};
  border-radius: var(--border-radius-8);
  ${FlexCenter}
`;

export const CellContent = styled.div<Props>`
  ${AlignCenter}
  flex-direction: column;
  justify-content: ${({ isTextCenter }) => (isTextCenter ? 'center' : 'flex-end')};
  gap: var(--space-4);
  width: 100%;
  height: 100%;
  position: relative;
`;

export const CheckmarkIcon = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  ${FlexCenter}
  z-index: var(--z-index-base);
`;

/* Overtime card specific components */

export const TimeBox = styled.div`
  margin-bottom: var(--space-7);
  max-width: calc(100% - 14px);
  width: 100%;
  background-color: var(--background-primary);
  border-radius: var(--border-radius-6);
  box-shadow: var(--border), var(--shadow-card);
  ${AlignCenter}
  flex-direction: column;
`;

export const TimeHours = styled.p<Props>`
  width: -webkit-fill-available;
  ${Typography.body_md_medium}
  color:${({ textColor }) => textColor || 'var(--text-placeholder)'};
  margin: var(--space-0);
  box-shadow: ${({ isOvertime }) => (isOvertime ? 'var(--bottom-border)' : 'none')};
  padding: var(--space-2);
  text-align: center;
`;

export const TimeLabel = styled.p`
  width: -webkit-fill-available;
  ${Typography.body_md_medium}
  color: var(--red);
  margin: var(--space-0);
  padding: var(--space-2);
  text-align: center;
`;

export const WeekendText = styled.div`
  ${Typography.body_md_medium}
  color: var(--text-placeholder);
  margin: var(--space-0);
  text-align: center;
`;
